import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import type { TemplateEditorThemeValues } from './template-editor-theme';

export type TemplateEditorStyleProps = { readOnly: boolean; error: boolean; hasSubtext: boolean };

export const baseEditorStyle = css`
  display: flex;
  flex-direction: column;
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing(2)};
  font-size: ${theme.fontSize(16)};

  p[data-slate-node='element'] span[data-slate-leaf] span[contenteditable='false'] {
    /* Style the placeholder text */
    color: ${theme.colors.neutral50};
    opacity: 1 !important; /* Override slate */
  }

  span[data-slate-void='true'] span[data-slate-spacer] {
    /* Needed to fix the cursor after a tag, so it doesn't look like a superscript */
    position: relative !important;
  }

  .message-template-slate-editor {
    flex: 1;
  }

  .extra-actions {
    display: flex;
    gap: ${theme.spacing(1)};
    align-items: center;
    margin-top: ${theme.spacing(1)};
  }
`;

export const editorErrorStyle = css`
  border-color: ${theme.colors.status.critical};
  p[data-slate-node='element'] span[data-slate-leaf] span[contenteditable='false'] {
    color: ${theme.colors.status.critical};
  }
`;

export const editorSubtextStyle = css`
  margin-bottom: ${theme.spacing(1)};
`;

export const editorFocusStyle = css`
  &:focus-within {
    box-shadow: 0 0 0 1px ${theme.colors.primary50};
    border-color: ${theme.colors.primary50};
  }
`;

export const editorFocusErrorStyle = css`
  &:focus-within {
    box-shadow: 0 0 0 1px ${theme.colors.status.critical};
    border-color: ${theme.colors.status.critical};
  }
`;

export const templateEditorStyle = (_theme: TemplateEditorThemeValues, props: TemplateEditorStyleProps) => {
  return cx(
    baseEditorStyle,
    props.error && editorErrorStyle,
    props.hasSubtext && editorSubtextStyle,
    !props.readOnly && (props.error ? editorFocusErrorStyle : editorFocusStyle)
  );
};
